import { render, staticRenderFns } from "./UpdatePointByRevenue.vue?vue&type=template&id=c13d5ee4&scoped=true&"
import script from "./UpdatePointByRevenue.vue?vue&type=script&lang=js&"
export * from "./UpdatePointByRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13d5ee4",
  null
  
)

export default component.exports